import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Header } from "./Header";
import { Footer } from "./Footer";

export function Layout({ children }) {
    const location = useLocation();
    useEffect(() => {
        if (location.hash) {
            // Wait a tick for the target section to render
            const id = location.hash.slice(1);
            requestAnimationFrame(() => {
                const el = document.getElementById(id);
                if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
                else window.scrollTo({ top: 0 });
            });
        } else {
            window.scrollTo({ top: 0, behavior: "instant" in window ? "instant" : "auto" });
        }
    }, [location.pathname, location.hash]);
    return (
        <div className="flex min-h-screen flex-col bg-background">
            <Header />
            <main className="flex-1" data-testid="page-main">
                {children}
            </main>
            <Footer />
        </div>
    );
}

export default Layout;
